import React, { useEffect } from 'react';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import AppSidebar from '@/features/product/components/AppSidebar';
import { useParams, Outlet } from 'react-router-dom';
import { useProductTheme } from '@/providers/theme-provider';

interface ProductLayoutProps {
    children?: React.ReactNode;
}

const ProductLayout: React.FC<ProductLayoutProps> = ({ children }) => {
    const { productSlug } = useParams<{ productSlug: string }>();
    const { setTheme } = useProductTheme();

    useEffect(() => {
        if (!productSlug) return;

        // Dynamic theme switching based on product
        if (productSlug.startsWith('bbps-')) {
            setTheme('slate');
        } else if (productSlug === 'lms-core') {
            setTheme('blue');
        } else {
            setTheme('global');
        }

        return () => setTheme('global');
    }, [productSlug, setTheme]);

    const isFullCockpit = productSlug && [
        'bbps-dashboard',
        'bbps-reports',
        'bbps-reconciliation',
        'bbps-backend',
        'bbps-architecture'
    ].includes(productSlug);

    return (
        <SidebarProvider defaultOpen={!isFullCockpit}>
            {!isFullCockpit && <AppSidebar />}
            <SidebarInset className="flex flex-col min-h-screen bg-transparent w-full">
                <main className="flex-1 w-full bg-transparent">
                    {children || <Outlet />}
                </main>
            </SidebarInset>
        </SidebarProvider>
    );
};

export default ProductLayout;
